module.exports = __webpack_public_path__ + "img/002.9b381332.png";